module.exports = __webpack_public_path__ + "img/picture_08.46b9b315.png";